var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayCheckIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.17 14.64C26.74 12.47 25.13 11.52 22.89 11.52H14.11C11.47 11.52 9.70996 12.84 9.70996 15.92V21.07C9.70996 23.29 10.62 24.59 12.12 25.15C12.34 25.23 12.58 25.3 12.83 25.34C13.23 25.43 13.66 25.47 14.11 25.47H22.9C25.54 25.47 27.3 24.15 27.3 21.07V15.92C27.3 15.45 27.26 15.03 27.17 14.64ZM13.53 20C13.53 20.41 13.19 20.75 12.78 20.75C12.37 20.75 12.03 20.41 12.03 20V17C12.03 16.59 12.37 16.25 12.78 16.25C13.19 16.25 13.53 16.59 13.53 17V20ZM18.5 21.14C17.04 21.14 15.86 19.96 15.86 18.5C15.86 17.04 17.04 15.86 18.5 15.86C19.96 15.86 21.14 17.04 21.14 18.5C21.14 19.96 19.96 21.14 18.5 21.14ZM24.96 20C24.96 20.41 24.62 20.75 24.21 20.75C23.8 20.75 23.46 20.41 23.46 20V17C23.46 16.59 23.8 16.25 24.21 16.25C24.62 16.25 24.96 16.59 24.96 17V20Z",
    fill: "#CD6422"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2998 18.92V24.07C30.2998 27.15 28.5398 28.48 25.8898 28.48H17.1098C16.3598 28.48 15.6898 28.37 15.1098 28.15C14.6398 27.98 14.2298 27.73 13.8998 27.41C13.7198 27.24 13.8598 26.97 14.1098 26.97H22.8898C26.5898 26.97 28.7898 24.77 28.7898 21.08V15.92C28.7898 15.68 29.0598 15.53 29.2298 15.71C29.9098 16.43 30.2998 17.48 30.2998 18.92Z",
    fill: "#CD6422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayCheckIconOrange);
export default __webpack_public_path__ + "static/media/payCheckIconOrange.a8e34a215b320379b729160dfcc8f2c4.svg";
export { ForwardRef as ReactComponent };